import Vue from "vue";
import Vuex from "vuex";
import authModule from "./modules/auth.module";
import reservationModule from "./modules/reservation.module";
import statisticsModule from "./modules/statistics.module";
import cacheInvalidationPlugin from "./plugins/cacheInvalidation";

Vue.use(Vuex);

/**
 * Plugin de persistance Vuex personnalisé
 * Utilise sessionStorage pour plus de sécurité (expire à la fermeture du navigateur)
 * Alternative : localStorage pour persistance longue durée
 */
const persistencePlugin = (store) => {
  // Restaurer l'état au démarrage
  const savedState = sessionStorage.getItem('vuex_auth_state');
  if (savedState) {
    try {
      const parsed = JSON.parse(savedState);
      store.replaceState({
        ...store.state,
        userAuthentified: parsed.userAuthentified,
        isAuthentified: parsed.isAuthentified,
      });
      console.log('✅ Session restaurée depuis sessionStorage');
    } catch (e) {
      console.error('❌ Erreur lors de la restauration de la session:', e);
      sessionStorage.removeItem('vuex_auth_state');
    }
  }

  // Sauvegarder automatiquement après chaque mutation
  store.subscribe((mutation, state) => {
    // Sauvegarder uniquement pour les mutations liées à l'authentification
    const authMutations = ['SET_USER_AUTHENTIFIED', 'LOGIN_USER', 'DESTROY_SESSION_USER', 'updateToken'];
    
    if (authMutations.includes(mutation.type)) {
      try {
        const stateToSave = {
          userAuthentified: state.userAuthentified,
          isAuthentified: state.isAuthentified,
        };
        sessionStorage.setItem('vuex_auth_state', JSON.stringify(stateToSave));
        
        if (mutation.type === 'DESTROY_SESSION_USER') {
          sessionStorage.removeItem('vuex_auth_state');
          console.log('🗑️ Session supprimée de sessionStorage');
        }
      } catch (e) {
        console.error('❌ Erreur lors de la sauvegarde de la session:', e);
      }
    }
  });
};

export default new Vuex.Store({
  state: {
    userAuthentified: {
      compagnieTransportId: null,
      compagnieTransportRaisonSociale: null,
      gareDesignation: null,
      email: null,
      login: null,
      nom: null,
      prenoms: null,
      lastConnection: null,
      roleCode: null,
      refreshToken: null,
      roleLibelle: null,
      token: null,
    },

    programmeDesignationSSE: null,

    ticket: {},

    reservationBillet: null,

    isAuthentified: false,

    pictureProfilUser: null,
  },

  getters: {},

  mutations: {
    STORE_PROGRAMME(state, data) {
      state.programmeDesignationSSE = data;
    },

    STORE_TICKET(state, data) {
      state.ticket = data;
    },

    STORE_RESERVATION_BILLET(state, data) {
      state.reservationBillet = data;
    },

    LOGIN_USER(state) {
      state.isAuthentified = true;
    },

    UPDATE_USER_PROFIL(state, data) {
      state.userAuthentified = data;
    },

    SET_USER_AUTHENTIFIED(state, data) {
      state.userAuthentified = data;
    },

    DESTROY_SESSION_USER(state) {
      state.isAuthentified = false;
      state.userAuthentified = {};
    },

    UPDATE_PICTURE_PROFIL(state, data) {
      state.pictureProfilUser = data;
    },

    updateToken(state, data) {
      state.userAuthentified.token = data.token;
      if (data.refreshToken) {
        state.userAuthentified.refreshToken = data.refreshToken;
      }
    },
  },
  actions: {
    setUser({ commit }, userData) {
      commit('SET_USER_AUTHENTIFIED', userData);
      commit('LOGIN_USER');
      // La persistance est gérée automatiquement par le plugin
    },
    logout({ commit }) {
      commit('DESTROY_SESSION_USER');
      // La suppression est gérée automatiquement par le plugin
    },
    destroySession({ commit }) {
      commit('DESTROY_SESSION_USER');
      // Alias pour logout, utilisé par les intercepteurs
    },
  },
  plugins: [persistencePlugin, cacheInvalidationPlugin],
  modules: {
    auth: authModule,
    reservation: reservationModule,
    statistics: statisticsModule,
  },
});
